<script>
import Dropdown from '../atoms/Dropdown'
import SearchResult from '@/components/molecules/SearchResult'
import SearchControl from '@/components/molecules/SearchControl'
import { mapGetters } from 'vuex'
import Spinner from '@/components/atoms/Spinner'

export default {
    name: 'Search',
    components: { Spinner, SearchControl, SearchResult, Dropdown },
    data() {
        return {
            searchValue: undefined,
            loading: false,
            result: {},
        }
    },
    computed: {
        ...mapGetters(['smDevice']),
        searchable() {
            return Boolean(this.$route.meta.searchable)
        },
        hasContent() {
            return Boolean(
                this.result.tags?.length ||
                    this.result.restaurants?.length ||
                    this.result.meals?.length
            )
        },
    },
    watch: {
        searchable(val) {
            if (!val) {
                this.searchValue = undefined
                this.result = {}
            }
        },
    },
    methods: {
        seeAll() {
            this.setQuery({ search: this.searchValue }, 'restaurant-list')
            this.$refs.searchControl.clear()
        },
        open(e) {
            e.stopPropagation()
            e.preventDefault()
            this.$refs.result.open()
            if (this.smDevice) {
                this.$refs.mobileSearch.onClick()
            }
        },
        close() {
            this.$refs.result.close()
        },
        async navigate() {
            this.close()
        },
    },
}
</script>

<template lang="pug">
transition(name="fade")
    .search(v-if="searchable")
        search-control(
            v-model="result"
            :search-value.sync="searchValue"
            :loading.sync="loading"
            @search="open"
            ref="searchControl"
            :display="smDevice"
            @open="open")
        dropdown.search-dropdown(
            ref="result"
            :class="{'loading': loading && hasContent}"
            right)
            template(v-if="smDevice" v-slot:header)
                .d-flex.align-items-center.w-100
                  .btn.btn-secondary.btn-icon.btn-sm.rounded-circle(@click="close")
                    icon(icon="fa-solid fa-arrow-left")
                  search-control.flex-grow-1(v-model="result" :search-value.sync="searchValue" :loading.sync="loading" ref="mobileSearch")
            template(v-slot:content)
                .text-center(v-if="loading && !hasContent")
                    spinner.mt-4(:size="40")
                template(v-else-if="hasContent")
                    span.text-sm.font-weight-semibold.dropdown-header(v-if="result.tags.length > 0") {{$t('labels.categories')}}
                    search-result(
                        v-for="tag in result.tags"
                        :result="tag"
                        @click="navigate"
                        :key="`searchResultTag-${tag.id}`"
                        tag)

                    .dropdown-divider(v-if="result.tags.length > 0 && result.restaurants.length > 0")

                    span.text-sm.font-weight-semibold.dropdown-header(v-if="result.restaurants.length") {{$t('labels.restaurants')}}
                    search-result(
                        v-for="(restaurant, index) in result.restaurants"
                        v-if="index < 3"
                        :result="restaurant"
                        @click="navigate"
                        :key="`searchResultRestaurant-${restaurant.id}`"
                        restaurant)
                    button.btn.btn-list-item(v-if="result.restaurants && result.restaurants.length > 3" @click="seeAll")
                        | {{$t('labels.see_all', { count: result.restaurants.length })}}

                    .dropdown-divider(v-if="result.restaurants.length && result.meals.length")

                    span.text-sm.font-weight-semibold.dropdown-header(v-if="result.meals.length") {{$t('labels.dishes')}}
                    search-result(
                        v-for="(meal, index) in result.meals"
                        :result="meal"
                        @click="navigate"
                        :key="`searchResultMeal-${meal.id}`"
                        meal)
                .text-center.mt-4(v-else) {{$t('labels.no_search_result')}}

</template>
